import {theme, Typography} from 'antd';
import React, {ReactNode} from 'react';

interface IProps {
  children: ReactNode;
  action?: ReactNode;
}

// "Section card" header pattern: an uppercase, letter-spaced title with a
// full-width divider below it, separating the header from the section's
// fields — an optional `action` (e.g. a button) sits to the right of the
// title, same row. Meant to sit as the first child inside an antd `<Card>`
// whose own body padding provides the surrounding card border/radius.
const SectionCardTitle: React.FC<IProps> = ({children, action}) => {
  const {token}: any = theme.useToken();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 12,
        paddingBottom: 14,
        marginBottom: 18,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
      }}>
      <Typography.Text
        style={{
          fontSize: 12,
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: 0.5,
          color: token.colorText,
        }}>
        {children}
      </Typography.Text>
      {action}
    </div>
  );
};

export default SectionCardTitle;
